import axios, { AxiosError, AxiosResponse } from "axios";
import { confirmAlert } from "react-confirm-alert";

// Function to refresh the access token
const refreshAccessToken = async () => {
  try {
    // Implement logic to refresh the access token, for example, by making a request to a refresh token endpoint
    const refreshToken = localStorage.getItem("refreshToken");
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/api/users/refresh-token",
      { refreshToken },
    );
    const newAccessToken = response.data.accessToken;
    localStorage.setItem("token", newAccessToken);

    // Retry the original request with the new access token
    return newAccessToken;
  } catch (err) {
    return false;
  }
};

/* Logout Start */
/*const logout = async () => {
  const response: any = await api.get(`api/users/logout`);
  localStorage.clear();
  sessionStorage.clear();
  return response.data.status;
};*/
/* Logout End */

/* const logout = async () => {
  try {
    const response: any = await api.patch(`/api/users/logout`);

    if (response) {
      localStorage.clear();
      sessionStorage.clear();
    }
    return response.data.status;
  } catch (error) {
    console.log(error);
  }

  return true;
}; */

// Create an Axios instance with a base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor
api.interceptors.request.use(
  async (config: any) => {
    // Add authorization header with the access token
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response: AxiosResponse) => {
    // You can do something with the successful response here
    return Promise.resolve(response); //response;
  },
  async (error: any) => {
    const originalRequest = error.config;

    // Check if the error is due to an expired access token
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      error.response.data.message === "jwt expired"
    ) {
      originalRequest._retry = true;

      const accessToken = localStorage.getItem("token");

      if (!accessToken) return false;

      try {
        // Attempt to refresh the access token
        const newAccessToken = await refreshAccessToken();

        if (!newAccessToken) {
          sessionExpire();
          return error;
        }

        // Update the original request with the new access token
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;

        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // Handle refresh token error (e.g., redirect to login)
        console.error("Refresh token error:", refreshError);
        // You might want to redirect the user to the login page or handle the error in some way
        // Example: history.push('/login');
        return Promise.reject(refreshError);
      }
    } else if (error.response && error.response.status === 402) {
      getData(error.response);
    }

    // Handle other types of errors
    return Promise.reject(error);
  },
);

const sessionExpire = () => {
  confirmAlert({
    title: "Session Expire",
    message: "Your session has expired. Please log in again to continue.",
    buttons: [
      {
        label: "Ok",
        className: "delete-btn",
        onClick: () => {
          console.log("logout");
          localStorage.clear();
          window.location.href = "/";
          /* const result = await logout();

          if (result) {
            window.location.href = "/login";
          } */
        },
      },
    ],
    overlayClassName: "overlay-custom-class-name",
    closeOnClickOutside: false,
    closeOnEscape: false,
  });
};

const getData = (res: any) => {
  confirmAlert({
    title:
      res?.data?.titleKey === "forcelogin"
        ? "Force Login"
        : res?.data?.titleKey === "userDelete"
          ? "User Remove"
          : "Inactive User",
    message: res?.data?.message
      ? res?.data?.message
      : "You have already logged in on another device",
    buttons: [
      {
        label: "Ok",
        className: "delete-btn",
        onClick: async () => {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        },
      },
    ],
    overlayClassName: "overlay-custom-class-name",
    closeOnClickOutside: false,
    closeOnEscape: false,
  });
};

export default api;
